// extracted by mini-css-extract-plugin
export var dotPoint = "styles-module--dotPoint--69ee2";
export var dotPointTips = "styles-module--dotPointTips--7f453";
export var dotPoints = "styles-module--dotPoints--7f4ff";
export var fullWidth = "styles-module--fullWidth--87e7e";
export var greenVariant = "styles-module--greenVariant--0d64b";
export var pointIcon = "styles-module--pointIcon--8550b";
export var pointText = "styles-module--pointText--043c3";
export var title = "styles-module--title--4aa0c";